import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from '../../styles.module.scss';

const cx = classnames.bind(styles);

export const ExpenseAccrualDateContent: FC<{
  paymentClosingDate?: string;
}> = ({ paymentClosingDate }) => {
  const { t } = useTranslation();

  return (
    <div className={cx('dynamicTextContainer')}>
      <div className={cx('singleLineText')}>
        {t(
          'ap_payee_detail_drawer_payment_rule_expense_accrual_date_content_application_date_from_nearest'
        )}{' '}
        <span>{paymentClosingDate}</span>
      </div>
      <div className={cx('stateText')}>
        {t('ap_payee_detail_drawer_payment_rule_expense_accrual_date_content')}
      </div>
    </div>
  );
};

ExpenseAccrualDateContent.displayName = 'ExpenseAccrualDateContent';
